// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logo-2 {\n  max-height: 24px;\n  opacity: 0.8;\n}\n.logo-control-2 {\n  opacity: 0.8;\n  padding-bottom: 0px;\n  text-align: end;\n  margin-bottom: 0px !important;\n  margin-right: 4px !important;\n}\n", ""]);
// Exports
module.exports = exports;
